<template>
  <div class="zones_clothes pt-3">
    <b-container v-if="typeof dist_zone_data !== 'undefined'" class="pt-4">
      <b-row>
    		<b-col cols="12">
          <table class="table text-center table-striped" v-if="total_zone_clothes > 0">
            <thead class="bg-grey-dark text-white">
              <tr>
                <th class="text-left" scope="col">{{trans['ROUPA']}}</th>
                <th class="text-right" scope="col">{{trans['QUANTIDADE']}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, key) in clothes_data" :key="key" class="text-left">
                <td scope="row" class="text-left">
                  {{item.complete_name}}&nbsp;
                  <span v-if="item.color !== null" class="d-inline-block rounded-circle align-middle color-stamp" :style="'background-color:' +item.color"></span>
                  <span v-if="item.color !== null">&nbsp;</span>
                  <span v-if="item.code !== null" class="d-inline-block rounded-pill bg-green-light py-1 px-2 text-white">
                    {{item.code}}
                  </span>
                </td>
                <td scope="row" class="text-right">{{item.total_quantity}}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th scope="row" class="text-left">{{trans['TOTAL']}}</th>
                <th scope="row" class="text-right">{{total_zone_clothes}}</th>
              </tr>
            </tfoot>
          </table>
          <b-alert v-else show variant="warning" class="text-center">{{trans['NAO_EXISTE_ROUPA_ATRIBUIDA_PARA']}}</b-alert>
        </b-col>
      </b-row>
  	</b-container>
  </div>
</template>

<script>

export default {
  name: 'zone_clothes',
  data() {
    return {
      
    }
  },
  methods: {

  },
  computed: {
    clothes_data: function() {
      let ret = {}, key_tmp;
      for(var r of this.dist_zone_data.rooms) {
        for(var cd of r.dist_room_clothes_details) {
          key_tmp = cd.cod_clothes+''+cd.cod_clothes_size;
          if(typeof ret[key_tmp] === 'undefined') {
            ret[key_tmp] = {
              complete_name : cd.complete_name,
              total_quantity: 0,
              color         : cd.color,
              code          : cd.code
            };
          }
          ret[key_tmp].total_quantity += parseInt(cd.pivot.quantity);
        }
      }
      return Object.values(ret).sort((a, b) => a.complete_name.toLowerCase().localeCompare(b.complete_name.toLowerCase()));
    },
    total_zone_clothes: function() {
      return Object.values(this.clothes_data).reduce((total, val) => total + val.total_quantity, 0);
    },
    dist_zone_data: function() {
      return this.get_zone();
    },
    send_data: function(items) {}, // just to exist and no error when main container call this
  },
  created: function() {
    if(typeof this.dist_zone_data === 'undefined') {
      this.$router.push({name: 'login', params: {lang: this.$route.params.lang}});
      return;
    }

    if(this.dist_zone_data.observation !== null) {
      this.$emit('set_modal_info', {title: this.trans['OBSERVACOES'], body: this.dist_zone_data.observation, has_btns: false});
    }
    this.$emit('set_back_link', {name: 'list_rooms', params: {lang: this.$route.params.lang, dist_zone: this.dist_zone_data,
                                                              search_hotel: this.$distribution.search_hotel,
                                                              search_bloco: this.$distribution.search_bloco,
                                                              search_piso: this.$distribution.search_piso,
                                                              search_n_quarto: this.$distribution.search_n_quarto}});
    this.$route.meta.title = this.trans['ROUPA']+' - '+this.trans['AREA'] +' '+this.dist_zone_data.distribution_num;
  }
}
</script>
